<template>
  <ref-link
    v-if="componentData.typeCode === 'RefLinkComponentModel'"
    :id="componentData.uid"
    :class="`${componentData.cssClass ?? ''} ${componentData.trekLinkStyle}`"
    :title="componentData.linkDisplayName"
    :link="componentData.link"
    :asset-type="componentData.assetType"
    :asset-location="componentData.assetLocation"
    :target="componentData.target"
  ></ref-link>
  <a
    v-else
    :id="componentData.uid"
    :href="componentData.url"
    :qaid="componentData.uid"
    :class="`${componentData.cssClass ?? ''} ${componentData.trekLinkStyle}`"
    :title="componentData.linkName"
    :aria-label="!componentData.linkName ? componentData.name : null"
    :target="isNewWindow ? '_blank' : null"
    :rel="isNewWindow ? 'noopener' : null"
    :data-video="componentData.video ?? null"
  >
    {{ componentData.linkName }}
  </a>
</template>
<script>
import {mapState} from 'vuex';
import RefLink from '@/components/ref-link/RefLink.vue';
export default {
  components: {
    RefLink,
  },
  props: {
    componentData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('backend', ['kioskModeEnabledOnSite']),
    isNewWindow() {
      return this.componentData.target === 'NEWWINDOW' && !this.kioskModeEnabledOnSite;
    },
  },
};
</script>
